import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { OnlineContractingStateMapping } from 'v3/data/store/onlineContracting/mapping';

export const OnlineContractingStatusMap: Record<OnlineContractingStateEnum, string> = Object.fromEntries(
  Object.entries(OnlineContractingStateMapping).map(([status, { title }]) => [status, title]),
) as Record<OnlineContractingStateEnum, string>;

export const getContractingStatusEnum = (title: string): OnlineContractingStateEnum | undefined => {
  return Object.keys(OnlineContractingStatusMap).find(
    (key) => OnlineContractingStatusMap[key as keyof typeof OnlineContractingStatusMap] === title,
  ) as OnlineContractingStateEnum | undefined;
};
